import React, {createContext, useMemo, useState} from 'react'

const OfferEditContext = createContext()
OfferEditContext.displayName = 'OfferUpdateContext'

const OfferUpdateProvider = ({children}) => {
    const [offerById, setOfferById] = useState([])
    const [stockList, setStockList] = useState([])
    const [bidList, setBidList] = useState([])

    const calculateSubTotal = () => {
        let subTotalObj = {
            "EUR": [],
            "USD": [],
            "TRY": []
        }
        bidList.map((item) => {
            if (item && item.selectedCurrency) {
                subTotalObj[item.selectedCurrency].push(item.lineTotal)
            }
        })

        return subTotalObj
    }

    const lineTotals = () => {
        bidList.map(item  => {
            if (item && item.stock) {

                if (item.hasOwnProperty('gift') && item.gift) {
                    item.lineTotal = 0
                    return
                }

                const total = (item.hasOwnProperty('linePrice') ? item.linePrice : item.price) * item.amount
                const [discount, secondDiscount] = [item.discount || 0 , item.discount2 || 0]
                const priceIterable = [total, discount, secondDiscount]
                item.lineTotal = priceIterable.reduce(rowTotalReducer)
            }
        })
    }

    const rowTotalReducer = (acc, crr) => acc - ((acc * crr) / 100)

    useMemo(() => lineTotals(), [bidList])
    const subTotal = useMemo(() => calculateSubTotal(), [bidList])

    const values = {
        byId: [offerById, setOfferById],
        subTotal: subTotal,
        stocks: [stockList, setStockList],
        bidContent: [bidList, setBidList],
    }

    return (
        <OfferEditContext.Provider value={values}>
            {children}
        </OfferEditContext.Provider>
    )
}

export {OfferEditContext, OfferUpdateProvider}